import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: François Risoud
 * id C34C0934-799C-40A5-8AD4-CE7A417C170B
 * name battery-minus
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/battery-minus.svg
 * tags
 * - Battery 
 */
export const BatteryMinusIcon = createSvgIcon(<><path d="M13.54 22H7.33C6.6 22 6 21.4 6 20.67V5.33C6 4.6 6.6 4 7.33 4H9V2H15V4H16.67C17.4 4 18 4.6 18 5.33V12C14.69 12 12 14.69 12 18C12 19.54 12.58 20.94 13.54 22M22 17V19H14V17H22Z" /></>, 'BatteryMinusIcon');
export default BatteryMinusIcon